import ArrowLeftCurve from "./SVG/arrowLeftCurve.svg?react";

const ArrowLeftCurveIcon = () => {
  return <ArrowLeftCurve />;
};

export default ArrowLeftCurveIcon;
